import DailyControlView from '../../pages/DailyControlView';

// Nome simples (PT): Página de Auditoria de Caixa
export default function PaginaAuditoriaCaixa(props) {
  return <DailyControlView {...props} />;
}






